import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import App from './App.vue';
import HomeView from './views/HomeView.vue';
import RoomView from './views/RoomView.vue';

import * as Sentry from "@sentry/vue";
import { registerServiceWorker } from './utils/pwa';



const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/r/:roomId',
      name: 'room',
      component: RoomView
    }
  ]
});

const app = createApp(App);

Sentry.init({
  app,
  dsn: "https://595d4d2969358781759ff27e60369cba@o364307.ingest.us.sentry.io/4510255872540672",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration({ router }),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ["localhost", /^https:\/\/mancu1\.ru/],
  // Session Replay
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
  // Logs
  enableLogs: true
});

app.use(router);

// Регистрируем Service Worker
if ('serviceWorker' in navigator) {
  registerServiceWorker().catch((error) => {
    console.error('❌ Ошибка регистрации Service Worker:', error);
  });
}

// Обрабатываем событие beforeinstallprompt для PWA установки
window.addEventListener('beforeinstallprompt', (e) => {
  // Предотвращаем стандартное поведение
  e.preventDefault();
  
  // Сохраняем событие для использования в компоненте
  (window as any).deferredPrompt = e;
  
  console.log('📱 PWA install prompt доступен');
});

app.mount('#app');
